import { fromPairs, merge } from "lodash";

import {
  SHOP_ACTIVITY_DETAILS_LOAD_REQUEST,
  SHOP_ACTIVITY_DETAILS_LOAD_SUCCESS,
  SHOP_ACTIVITY_DETAILS_LOAD_FAILURE,
  SHOP_ACTIVITIES_LOAD_REQUEST,
  SHOP_ACTIVITIES_LOAD_SUCCESS,
  SHOP_ACTIVITIES_LOAD_FAILURE,
  MY_ACTIVITIES_ADD_REQUEST,
  MY_ACTIVITIES_ADD_SUCCESS,
  MY_ACTIVITIES_ADD_FAILURE,
  MY_ACTIVITIES_REMOVE_REQUEST,
  MY_ACTIVITIES_REMOVE_SUCCESS,
  MY_ACTIVITIES_REMOVE_FAILURE,
  MY_ACTIVITIES_RESEND_REQUEST,
  MY_ACTIVITIES_RESEND_SUCCESS,
  MY_ACTIVITIES_RESEND_FAILURE,
  MY_ACTIVITIES_RESET_RELOAD,
  SIGNEDUP_ACTIVITIES_LOAD_REQUEST,
  SIGNEDUP_ACTIVITIES_LOAD_SUCCESS,
  SIGNEDUP_ACTIVITIES_LOAD_FAILURE,
} from "../actions/shopActivitiesActions";

const initialState = {
  data: null,
  fetching: false,
  fetched: false,
  error: null,
};

const initialSignupsState = {
  data: null,
  activity: null,
  shouldReload: false,
  fetching: false,
  fetched: false,
  error: null,
  resendStatus: null,
};

export function shopActivityDetails(state = initialState, action = {}) {
  switch (action.type) {
    case SHOP_ACTIVITY_DETAILS_LOAD_REQUEST:
      return { ...state, fetching: true, data: null };
    case SHOP_ACTIVITY_DETAILS_LOAD_FAILURE:
      return { ...state, fetching: false, error: action.payload };
    case SHOP_ACTIVITY_DETAILS_LOAD_SUCCESS:
      return { ...state, fetching: false, fetched: true, data: action.payload };
    default:
      return state;
  }
}

export function shopActivities(state = initialState, action = {}) {
  switch (action.type) {
    case SHOP_ACTIVITIES_LOAD_REQUEST:
      return { ...state, fetching: true };
    case SHOP_ACTIVITIES_LOAD_FAILURE:
      return { ...state, fetching: false, error: action.payload };
    case SHOP_ACTIVITIES_LOAD_SUCCESS:
      return { ...state, fetching: false, fetched: true, data: action.payload };
    default:
      return state;
  }
}

export function signedUpActivities(state = initialState, action = {}) {
  switch (action.type) {
    case SIGNEDUP_ACTIVITIES_LOAD_REQUEST:
      return { ...state, fetching: true };
    case SIGNEDUP_ACTIVITIES_LOAD_FAILURE:
      return { ...state, fetching: false, error: action.payload };
    case SIGNEDUP_ACTIVITIES_LOAD_SUCCESS:
      return { ...state, fetching: false, fetched: true, data: action.payload };
    default:
      return state;
  }
}

const voucherSending = action => ({
  fetching: true, // first 4 are from old code, not sure on their effect
  shouldReload: false,
  data: null,
  activity: action.payload,
  resendStatus: action.type, // recycling the action type as enum status
});

const voucherSent = action => ({
  fetching: false, // first 4 are from old code, not sure on their effect
  fetched: true,
  data: action.payload,
  resendStatus: action.type,
});

const voucherFailed = action => ({
  fetching: false,
  error: action.payload,
  resendStatus: action.type,
});

const VoucherReducers = fromPairs([
  [MY_ACTIVITIES_RESEND_SUCCESS, voucherSent],
  [MY_ACTIVITIES_RESEND_REQUEST, voucherSending],
  [MY_ACTIVITIES_RESEND_FAILURE, voucherFailed],
]);

export function shopActivity(state = initialSignupsState, action = {}) {
  if (VoucherReducers[action.type]) {
    return merge({}, state, VoucherReducers[action.type](action));
  }

  switch (action.type) {
    case MY_ACTIVITIES_RESET_RELOAD:
      return { ...state, shouldReload: false };
    case MY_ACTIVITIES_ADD_REQUEST:
    case MY_ACTIVITIES_REMOVE_REQUEST:
      return {
        ...state,
        fetching: true,
        shouldReload: false,
        data: null,
        activity: action.payload,
      };
    case MY_ACTIVITIES_ADD_FAILURE:
    case MY_ACTIVITIES_REMOVE_FAILURE:
      return { ...state, fetching: false, error: action.payload };
    case MY_ACTIVITIES_ADD_SUCCESS:
    case MY_ACTIVITIES_REMOVE_SUCCESS:
      return {
        ...state,
        fetching: false,
        shouldReload: true,
        fetched: true,
        data: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/shopActivitiesReducer.jsx